import { Button, ButtonProps } from '@/shadcn-ui/button';
import { cn } from '@/shadcn-ui/utils';
import { forwardRef } from 'react';

interface InvoiceLineItemTitleTriggerProps extends ButtonProps {
  title: string;
}

const InvoiceLineItemTitleTrigger = forwardRef<
  HTMLButtonElement,
  InvoiceLineItemTitleTriggerProps
>(({ title, className, ...props }: InvoiceLineItemTitleTriggerProps, ref) => {
  return (
    <Button
      variant="clear"
      type="button"
      className={cn(
        'link-dashed-body h-auto text-flexcar-neutral10 focus:text-flexcar-neutral10 focus:outline-none focus:ring-0 active:outline-none active:ring-0',
        className
      )}
      ref={ref}
      {...props}
    >
      {title}
    </Button>
  );
});

InvoiceLineItemTitleTrigger.displayName = 'InvoiceLineItemTitleTrigger';

export default InvoiceLineItemTitleTrigger;
